import { RouterProvider } from '@app/router';

import { ERPCoreProvider } from '@erp-core/providers/ERPCoreProvider';

import { QueryProvider } from './QueryProvider';
import { SessionRestoreProvider } from './SessionRestoreProvider';
import { ThemeProvider } from './ThemeProvider';

/**
 * Root provider composition.
 * Order matters:
 *  1. ThemeProvider — CSS variables available before any child renders.
 *  2. QueryProvider — TanStack Query available for all data hooks.
 *  3. SessionRestoreProvider — silently restores access token from refresh
 *     token on every reload BEFORE AuthGuard evaluates isAuthenticated.
 *     Keeps isLoading=true during restore so the guard shows a spinner
 *     instead of flashing the login page.
 *  4. ERPCoreProvider / RouterProvider — actual app tree.
 */
export function AppProvider() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <SessionRestoreProvider>
          <ERPCoreProvider>
            <RouterProvider />
          </ERPCoreProvider>
        </SessionRestoreProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
